module.exports = __webpack_public_path__ + "static/media/logo.43d455c0.png";